import { render, staticRenderFns } from "./LeadManagementLegend.vue?vue&type=template&id=4b5f0001&"
import script from "./LeadManagementLegend.vue?vue&type=script&lang=js&"
export * from "./LeadManagementLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports